import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const formatINR = (n) => {
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2).replace(/\.00$/, "")} Lakh`;
  return `₹${Number(n).toLocaleString("en-IN")}`;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(", ");
  return d || e?.message || "Something went wrong";
};

export function useAuthedApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, extra = {}) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${url}`, data, ...extra, headers: { Authorization: `Bearer ${token}`, ...(extra.headers || {}) } });
      return res.data;
    },
    [getToken]
  );
}
